export const REGISTRATION_FIELDS_ERRORS = {
    acceptPolicy: ['error.policy_not_accepted'],
    email: ['error.already_registered', 'error.email_not_valid', 'error.email_required'],
    password: ['error.password_max_length', 'error.password_min_length', 'error.password_simple'],
}
